import dynamic from 'next/dynamic';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Utils
import useToggle from '@/utils/hooks/utils/useToggle';

// Types
import type { SocialProfileType } from '@/types/socialProfileType';

import Button from '@/components/base/Button';
// Components
import Icon from '@/components/base/Icon';
import Tooltip from '@/components/base/Tooltip';
import { ButtonUnlockPermission } from '@/components/pages/scheduler/SchedulerHeader/UnlockSchedulerPermission/ButtonUnlockPermission';

const ModalUnlockPermissionMultiProfiles = dynamic(() =>
    import(
        '@/components/pages/scheduler/SchedulerHeader/UnlockSchedulerPermission/ModalUnlockPermissionMultiProfiles'
    ).then((mod) => mod.ModalUnlockPermissionMultiProfiles)
);

type UnlockSchedulerPermissionProps = {
    activeSocialProfile: SocialProfileType;
};

export function UnlockSchedulerPermission({ activeSocialProfile }: UnlockSchedulerPermissionProps) {
    const { t } = useTranslation('scheduler');
    const { isOpen, toggle } = useToggle();

    if (activeSocialProfile) {
        return <ButtonUnlockPermission activeSocialProfile={activeSocialProfile} />;
    }

    return (
        <>
            <Tooltip content={t('unlock_auto_posting')}>
                <Button
                    data-testid="unlock-scheduler-permission-multi-profiles-button"
                    className="w-12 !min-w-min !px-0"
                    variant={'whiteNoBorder'}
                    onClick={toggle}>
                    <Icon icon="autopost-no" />
                </Button>
            </Tooltip>
            <ModalUnlockPermissionMultiProfiles isOpen={isOpen} toggle={toggle} />
        </>
    );
}
